// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4a6fe103","239":"cf5004bc","391":"a6be807b"}[chunkId] + ".chunk.js";
};